export default __webpack_public_path__ + "static/media/creteround-regular-webfont.d3c39cb4.woff2";